import * as React from 'react';

import Footer from 'modules/footer';
import { links } from './fr-footer.structure';
import { IFRFooterProps } from './fr-footer.types';

const FRFooter: React.FC<IFRFooterProps> = ({
    config,
    activeLanguageCode,
    fetchLanguage
}) => (
    <Footer
        availablePlatforms={config.platformSelection}
        activeLanguageCode={activeLanguageCode}
        availableLanguageTags={config.availableLanguages}
        fetchLanguage={fetchLanguage}
        linksList={links}
    />
);

export default FRFooter;
